import type { FrontendWidget } from '../types';
import type { WhatsappConfig, WhatsappResolved } from './types';
import { WhatsappComponent } from './WhatsappComponent';

export const whatsappWidget: FrontendWidget<WhatsappConfig, WhatsappResolved> =
  {
    componentType: 'widgets.whatsapp',
    displayName: 'WhatsApp',
    ComponentA: WhatsappComponent,
    resolveSync: (config) => config,
  };
